export enum ContractSettingLogModifiedField {
    contractPrice = 'contractPrice',
    endDate = 'endDate',
    startDate = 'startDate',
}
